import { Button, Menu, MenuItem, MenuSections } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { NoSettingsAlert } from "@web-src/modules/invoices/components/NoSettingsAlert";
import { ReactNode, useState } from "react";
import { InvoiceType } from "@jugl-web/rest-api/invoices/models/common-types";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";
import { ReactComponent as InvoiceIcon } from "./assets/invoice.svg";
import { ReactComponent as ProformaIcon } from "./assets/proforma.svg";
import { ReactComponent as EstimateIcon } from "./assets/estimate.svg";
import { ReactComponent as PurchaseOrderIcon } from "./assets/purchase-order.svg";

import { useInvoicesConfigList } from "../../../InvoicesSettingsPage/pages/InvoicesBusinessInformationPage/hooks/useInvoicesConfigList";

type SelectItem = { id: InvoiceType; label: string; icon: ReactNode };

export const InvoicesCreate = () => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();
  const { configId } = useInvoicesConfigList();
  const [noSettingsAlertType, setNoSettingsAlertType] =
    useState<InvoiceType | null>(null);

  const handleSelect = (item: MenuItem<SelectItem>) => {
    if (configId) {
      // @ts-expect-error TODO: fix this
      navigateToPage("invoicesItemForm", { type: item.id });
    } else {
      setNoSettingsAlertType(item.id as InvoiceType);
    }
  };

  const menuSections: MenuSections<SelectItem> = [
    [
      {
        id: "invoice",
        label: t({
          id: "invoices-items-page.create-new-invoice",
          defaultMessage: "New Invoice",
        }),
        icon: <InvoiceIcon />,
      },
      {
        id: "proforma",
        label: t({
          id: "invoices-items-page.create-new-proforma",
          defaultMessage: "New Proforma",
        }),
        icon: <ProformaIcon />,
      },
      {
        id: "estimate",
        label: t({
          id: "invoices-items-page.create-new-estimate",
          defaultMessage: "New Estimate",
        }),
        icon: <EstimateIcon />,
      },
      {
        id: "purchase_order",
        label: t({
          id: "invoices-items-page.create-new-purchase-order",
          defaultMessage: "New Purchase Order",
        }),
        icon: <PurchaseOrderIcon />,
      },
    ],
  ];

  return (
    <div>
      <Menu
        placement="bottom-start"
        sections={menuSections}
        onSelect={(_item, _event, close) => {
          handleSelect(_item);
          close();
        }}
        renderTrigger={({ Trigger, triggerRef }) => (
          <Trigger
            ref={triggerRef}
            as={Button}
            className="h-10"
            iconEnd={<ChevronIcon />}
          >
            {t({
              id: "invoices-items-page.create-new",
              defaultMessage: "Create New",
            })}
          </Trigger>
        )}
      />

      <NoSettingsAlert
        isOpen={!!noSettingsAlertType}
        onAccept={() => setNoSettingsAlertType(null)}
        onCancel={() => setNoSettingsAlertType(null)}
        type={noSettingsAlertType ?? undefined}
      />
    </div>
  );
};
